// Safari can turn a downward drag at the top of Browse into a page reload,
// even with overscroll-behavior set. Keep ordinary/nested scrolling native.
export function preventPullRefresh(doc = document) {
  const root = doc.documentElement;
  const attribute = 'data-slab-browse-scroll';
  const previous = root.getAttribute(attribute);
  root.setAttribute(attribute, '');
  let gesture = null;

  function start(event) {
    const touch = event.touches.length === 1 ? event.touches[0] : null;
    gesture = touch ? { id: touch.identifier, x: touch.clientX, y: touch.clientY, lastY: touch.clientY } : null;
  }

  function canScrollUp(target) {
    const scroller = doc.scrollingElement || root;
    for (let element = target?.nodeType === 1 ? target : target?.parentElement; element; element = element.parentElement) {
      if (element === scroller) break;
      const style = doc.defaultView.getComputedStyle(element);
      if (!/^(auto|scroll|overlay)$/.test(style.overflowY) || element.scrollHeight <= element.clientHeight) continue;
      if (element.scrollTop > 0) return true;
      // A contained sheet/list must not pass its top-edge drag to the page.
      if (style.overscrollBehaviorY === 'contain' || style.overscrollBehaviorY === 'none') return false;
    }
    return scroller.scrollTop > 0;
  }

  function move(event) {
    if (!gesture || event.touches.length !== 1) { gesture = null; return; }
    const touch = event.touches[0];
    if (touch.identifier !== gesture.id) { gesture = null; return; }
    const down = touch.clientY > gesture.lastY;
    gesture.lastY = touch.clientY;
    const dx = touch.clientX - gesture.x;
    const dy = touch.clientY - gesture.y;
    // Horizontal slab swipes, upward scrolling and pinch zoom remain native.
    if (!down || dy <= 0 || Math.abs(dx) >= Math.abs(dy) || canScrollUp(event.target)) return;
    if (event.cancelable && !event.defaultPrevented) event.preventDefault();
  }

  function end() { gesture = null; }
  doc.addEventListener('touchstart', start, { passive: true });
  doc.addEventListener('touchmove', move, { passive: false });
  doc.addEventListener('touchend', end, { passive: true });
  doc.addEventListener('touchcancel', end, { passive: true });
  return () => {
    doc.removeEventListener('touchstart', start);
    doc.removeEventListener('touchmove', move);
    doc.removeEventListener('touchend', end);
    doc.removeEventListener('touchcancel', end);
    if (previous === null) root.removeAttribute(attribute);
    else root.setAttribute(attribute, previous);
  };
}
